import React from "react";
import { useNavigate } from "react-router-dom";
import "../css.css";
import Footer from './Footer'
import Header from "./Header";

const PublicDashboard = () => {
  const navigate = useNavigate();

  // Sample public agents - you can modify or add more as needed
  const publicAgents = [
    {
      id: "public-1",
      name: "Innospace Assistant",
      iconSrc: "/bot.png",
      path: "/innospace-assistant-nonAuth",
      description: "A general purpose AI assistant for common queries",
    },
    {
      id: "public-2", 
      name: "EKB Agent",
      iconSrc: "/innospace_bot.png",
      path: "/ekb-agent",
      description: "Get Theaisle.ai revolutionizes enterprise knowledge access",
    },
    {
      id: "public-3",
      name: "Internship Placement Assistant",
      iconSrc: "/digital_bot.png", 
      path: "/internship-placement-nonAuth",
      description: "Internship placement assistance and guidance",
    },
    {
      id: "public-4",
      name: "InfiniAI Assistant",
      iconSrc: "/internship_bot.png",
      path: "/infiniai-nonAuth",
      description: "Unlock the full potential of in the field of AI",
    },
    {
      id: "public-5",
      name: "SLTMNIT Assistant",
      iconSrc: "/sltmnit.png",
      path: "/sltmnit",
      description: "Specialized assistant for SLTMNIT"
    },
    {
      id: "public-6",
      name: "Support Assistant",
      iconSrc: "/embryo_bot.png",
      description: "Basic support and guidance assistant",
      comingSoon: true
    }
  ];

  const handleAgentClick = (agent) => {
    if (agent.comingSoon) {
      alert("This agent is coming soon! Stay tuned for updates.");
    } else {
      // Navigate to agent page when implemented
      navigate(agent.path);
    }
  };

  const handleBackToHome = () => {
    navigate("/prelogin");
  };

  return (
    <>
      {/* Logos */}
      <Header/>

      <div style={{
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          marginBottom: '30px',
          flexWrap: 'wrap',
          gap: '15px'
      }}>
        <div className="container">
          {/* Header with back button */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '30px',
            flexWrap: 'wrap',
            gap: '15px'
          }}>
            <div>
              <h1 style={{ margin: 0, fontSize: '32px' }}>Public Agent Dashboard</h1>
              <p style={{ 
                margin: '5px 0 0 0', 
                color: '#ccc', 
                fontSize: '16px' 
              }}>
                Explore our publicly available AI agents
              </p>
            </div>
            
            {/* <button 
              onClick={handleBackToHome}
              style={{
                background: 'linear-gradient(135deg, #6c5ce7, #a29bfe)',
                color: 'white',
                padding: '12px 20px',
                fontSize: '14px',
                fontWeight: '600',
                border: 'none',
                borderRadius: '25px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                whiteSpace: 'nowrap'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.background = 'linear-gradient(135deg, #5f3dc4, #9775fa)';
                e.target.style.boxShadow = '0 6px 18px rgba(0, 0, 0, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.background = 'linear-gradient(135deg, #6c5ce7, #a29bfe)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
              }}
            >
              ← Back to Home
            </button> */}


            <button className="button back" onClick={handleBackToHome}>
              <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1024 1024"><path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z"></path></svg>
              <span>Back</span>
            </button>
          </div>

          {/* Agents Grid */}
          <div className="agents-grid" style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            justifyContent: 'center', 
            gap: '25px' 
          }}>
            {publicAgents.map((agent) => (
              <PublicAgentCard
                key={agent.id}
                agent={agent}
                onClick={() => handleAgentClick(agent)}
              />
            ))}
          </div>

          {/* Info Section */}
          <div style={{
            marginTop: '40px',
            padding: '25px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '12px',
            textAlign: 'center',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h3 style={{ color: '#fff', marginBottom: '15px' }}>About Public Agents</h3>
            <p style={{ 
              color: '#ccc', 
              fontSize: '16px', 
              lineHeight: '1.6',
              margin: 0 
            }}>
              These agents are available to everyone without login. They provide basic functionality 
              and general assistance. For advanced features and personalized experiences, 
              consider using our authenticated agents.
            </p>
          </div>

          {/* Access Info */}
          <div style={{
            marginTop: '30px',
            padding: '20px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <p style={{ 
              color: '#ccc', 
              fontSize: '14px', 
              margin: 0,
              lineHeight: '1.5'
            }}>
              Access Level: <strong>Public</strong> | 
              Available Agents: <strong>{publicAgents.length}</strong> | 
              Status: <strong>No Login Required</strong>
            </p>
          </div>
        </div>
      </div>
      <Footer />

    </>
  );
};

const PublicAgentCard = ({ agent, onClick }) => (
  <div 
    className="agent-card" 
    onClick={onClick}
    style={{
      position: 'relative',
      opacity: agent.comingSoon ? 0.7 : 1
    }}
  >
    <img 
      src={agent.iconSrc} 
      alt={`${agent.name} Icon`} 
      className="agent-icon" 
    />
    <div className="agent-name">{agent.name}</div>
    <p style={{
      fontSize: '13px',
      color: '#ccc',
      margin: '10px 0 0 0',
      lineHeight: '1.4'
    }}>
      {agent.description}
    </p>
    
    {agent.comingSoon && (
      <div style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        background: 'rgba(255, 165, 0, 0.9)',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '10px',
        fontWeight: '600'
      }}>
        Coming Soon
      </div>
    )}
  </div>

);

export default PublicDashboard;